import { useRouteError, useNavigate } from "react-router-dom";
import { Container, Paper, Title, Text, Button, Stack, Group, Code, ThemeIcon } from "@mantine/core";
import { IconAlertCircle, IconRefresh, IconArrowLeft, IconCopy } from "@tabler/icons-react";
import { log as logger } from "../../../utils/logger";

export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();

  // Log the error with safe serialization
  try {
    logger.error("Route error", {
      message: error?.message || "Unknown error",
      stack: error?.stack || "No stack trace available",
      statusText: error?.statusText || "No status text",
      data: error?.data || null,
    });
  } catch (logError) {
    console.error("Failed to log route error:", logError);
  }

  const errorMessage = error?.message || error?.statusText || "An unexpected error occurred";
  const errorStack = error?.stack;

  return (
    <Container size="md" py="xl">
      <Paper shadow="md" p="xl" radius="md" withBorder>
        <Stack align="center" spacing="lg">
          <ThemeIcon size={60} radius={60} color="red">
            <IconAlertCircle size={32} />
          </ThemeIcon>

          <Title order={2} ta="center" color="red">
            Error
          </Title>

          <Text size="lg" c="red" ta="center" fw={500}>
            {errorMessage}
          </Text>

          <Group>
            <Button leftSection={<IconArrowLeft size={16} />} variant="light" onClick={() => navigate(-1)}>
              Go Back
            </Button>
            <Button leftSection={<IconRefresh size={16} />} onClick={() => window.location.reload()}>
              Refresh Page
            </Button>
          </Group>

          {process.env.NODE_ENV === "development" && errorStack && (
            <Stack align="stretch" w="100%">
              <Text fw={500}>Technical Details:</Text>
              <Code block style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {errorStack}
              </Code>
              <Button
                variant="subtle"
                leftSection={<IconCopy size={16} />}
                onClick={() => navigator.clipboard.writeText(errorStack)}
              >
                Copy Error Details
              </Button>
            </Stack>
          )}
        </Stack>
      </Paper>
    </Container>
  );
}

export default RouteError;
